import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { ChipProps } from '@clds/chip';
import { Icon } from '@cld/icon';
import { messages } from '../../i18n';
import { RecipeComplexity } from '../../types';
import { ChipWithTooltip } from '../ChipWithTooltip/ChipWithTooltip';

export interface ComplexityTagProps extends Omit<ChipProps, 'label' | 'leftSlot'> {
  /** Defines icon and text of the Tag */
  complexity: RecipeComplexity;
}

enum ComplexityIcon {
  beginner = 'complexityBeginner',
  intermediate = 'complexityIntermediate',
  advanced = 'complexityAdvanced',
}

/**
 * Used to display recipe's complexity in a form of chip and icon
 */
export const ComplexityTag: FC<React.PropsWithChildren<ComplexityTagProps>> = ({ complexity, ...chipProps }) => {
  const { formatMessage } = useIntl();
  const complexityName = formatMessage(messages[complexity]);

  return <ChipWithTooltip leftSlot={<Icon size="md" name={ComplexityIcon[complexity]} />} label={complexityName} {...chipProps} />;
};
